import { getIn, useFormikContext } from 'formik';
import * as React from 'react';

import { Input, type InputProps } from '@/design-system/components/ui';

export interface FormikInputProps extends Omit<InputProps, 'error' | 'errorMessage' | 'value' | 'onChange' | 'onBlur'> {
  name: string;
}

const FormikInput = React.forwardRef<HTMLInputElement, FormikInputProps>(({ name, ...props }, ref) => {
  const { values, errors, touched, handleChange, handleBlur } = useFormikContext();

  const value = getIn(values, name) ?? '';
  const error = getIn(errors, name);
  const fieldTouched = getIn(touched, name);
  const errorMessage = fieldTouched && typeof error === 'string' ? error : undefined;

  return (
    <Input
      ref={ref}
      name={name}
      value={value}
      onChange={handleChange}
      onBlur={handleBlur}
      error={Boolean(fieldTouched && error)}
      errorMessage={errorMessage}
      {...props}
    />
  );
});

FormikInput.displayName = 'FormikInput';

export { FormikInput };
